import { render, staticRenderFns } from "./ServiceChargeManaged.vue?vue&type=template&id=240727b0&scoped=true&"
import script from "./ServiceChargeManaged.vue?vue&type=script&lang=js&"
export * from "./ServiceChargeManaged.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChargeManaged.vue?vue&type=style&index=0&id=240727b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240727b0",
  null
  
)

export default component.exports